import { render, staticRenderFns } from "./NewLink.vue?vue&type=template&id=0cc9f914&"
import script from "./NewLink.vue?vue&type=script&lang=js&"
export * from "./NewLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports